import {useInfiniteQuery} from '@tanstack/react-query'
import {httpGetViews, HttpGetViewsOptions} from '../http/views.http'
import {QUERY_KEYS} from '@/queryClient'
import {infiniteQueryFetchNextPage} from '@/utilities/helpers'

export const useGetViews = (params: Omit<HttpGetViewsOptions['params'], 'page'>) => {
    const query = useInfiniteQuery({
        queryKey: [QUERY_KEYS.VIEWS, params],
        queryFn: ({pageParam = 1}) =>
            httpGetViews({
                params: {
                    page: pageParam,
                    ...params
                }
            }),
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })

    return {
        ...query,
        fetchNextPage: () => infiniteQueryFetchNextPage(query),
        remappedData: query.data?.pages[0]?.data?.length ? query.data.pages.flatMap(page => page.data) : []
    }
}
